import { css, styled } from '@mui/material';

import { ButtonBase } from '../ButtonBase';
import { buttonGhostClasses } from './theme';

import type { ButtonGhostOwnerState, ButtonGhostProps } from './types';

export default function ButtonGhost(props: ButtonGhostProps) {
  const { children, variant = 'primary', size = 'xl', disabled = false, ...others } = props;

  const ownerState: ButtonGhostOwnerState = {
    ...props,
    variant,
    size,
    disabled,
  };

  return (
    <ButtonGhostRoot
      appearance="ghost"
      content="text"
      variant={variant}
      size={size}
      disabled={disabled}
      ownerState={ownerState}
      {...others}
    >
      <ButtonGhostLabel ownerState={ownerState}>{children}</ButtonGhostLabel>
    </ButtonGhostRoot>
  );
}
ButtonGhost.displayName = 'ButtonGhost';

const ButtonGhostRoot = styled(ButtonBase, {
  target: buttonGhostClasses.root,
})<{ ownerState: ButtonGhostOwnerState }>``;

const ButtonGhostLabel = styled('span', {
  target: buttonGhostClasses.label,
})<{ ownerState: ButtonGhostOwnerState }>(({ ownerState }) => {
  const { size } = ownerState;

  // size별 padding 스타일
  if (size === 'sm') {
    return css`
      padding: 0px 2px;
    `;
  }

  // xl, lg, md는 모두 동일
  return css`
    padding: 0px 4px;
  `;
});
